import StyledSlider from "common/Slider/StyledSlider";
import { useState } from "react";
import {
  SelectorInput,
  SelectorLabel,
  SelectorValueName,
  SelectorWrapper,
} from "features/admin/group/InvitationModal/InvitationSelectors/styles";
import { useTheme } from "styled-components";
import { getUpdatedMarks } from "features/admin/group/InvitationModal/InvitationSelectors/helpers";
import Text from "common/Typography/Text";
import Title from "common/Typography/Title";
import { InfinityIcon } from "common/Icons/Icons";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";
const MARKS = {
  0: "1",
  20: "7",
  40: "30",
  60: "180",
  80: "365",
  100: {
    label: <InfinityIcon style={{ fontSize: 20 }} />,
  },
};

const useSubscriptionDurationSelector = (invitation) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.ADMIN);
  const { isNewLook } = useTheme();
  const [selectedDuration, setSelectedDuration] = useState(
    invitation && invitation.subscription_duration
  );
  const [marks, selectedMarkKey] = getUpdatedMarks(MARKS, selectedDuration);

  const getDurationFromMarkKey = (sliderValue) => {
    if (sliderValue === 100) {
      return null;
    }
    return parseInt(marks[sliderValue]);
  };

  const changeDuration = (value) => {
    let updatedDuration = value;
    if (updatedDuration < 1) {
      updatedDuration = null;
    }
    setSelectedDuration(updatedDuration);
  };

  const subscriptionDurationSelectorComponent = isNewLook ? (
    // New look: the same label + well as the number of users.
    <div style={{ marginTop: 20 }}>
      <SelectorLabel>{t("invitations.modal.durationLabel")}</SelectorLabel>
      <SelectorWrapper>
        <StyledSlider
          marks={marks}
          min={0}
          max={100}
          step={20}
          tooltip={{ open: false }}
          value={selectedMarkKey || 100}
          onChange={(value) => {
            changeDuration(getDurationFromMarkKey(value));
          }}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingTop: "8px",
          }}
        >
          <SelectorValueName>
            {t("invitations.modal.durationTitle")}
          </SelectorValueName>
          <SelectorInput
            bordered={false}
            style={{
              width: "100px",
              textAlign: "end",
              padding: "0",
            }}
            placeholder={t("invitations.modal.lifetime")}
            value={selectedDuration}
            onChange={changeDuration}
          />
        </div>
      </SelectorWrapper>
    </div>
  ) : (
    <div
      style={{
        marginTop: "24px",
      }}
    >
      <Text>{t("invitations.modal.durationLabel")}</Text>
      <SelectorWrapper>
        <StyledSlider
          marks={marks}
          min={0}
          max={100}
          step={20}
          tooltip={{ open: false }}
          value={selectedMarkKey || 100}
          onChange={(value) => {
            changeDuration(getDurationFromMarkKey(value));
          }}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingTop: "12px",
          }}
        >
          <Title level={4} style={{ fontWeight: 500 }}>
            {t("invitations.modal.durationTitle")}
          </Title>
          <SelectorInput
            bordered={false}
            style={{
              width: "100px",
              textAlign: "end",
              padding: "0",
            }}
            placeholder={t("invitations.modal.lifetime")}
            value={selectedDuration}
            onChange={changeDuration}
          />
        </div>
      </SelectorWrapper>
    </div>
  );

  return [subscriptionDurationSelectorComponent, selectedDuration];
};

export default useSubscriptionDurationSelector;
